// extracted by mini-css-extract-plugin
export var container = "g0_c";
export var description = "g0_p";
export var logoContainer = "g0_mB";
export var socialsContainer = "g0_pJ";